<template>
    <div>
        <header-message class="mt-3 mb-3">Installing ...</header-message>
        <header-message class="mb-3 text-warning">
            Do not turn off the device while the upgrade is being installed.
        </header-message>
        <header-message class="mb-3">
            Installation may take several minutes.
        </header-message>
    </div>
</template>

<style lang="scss">
    .desc.status {
        font-size: 1.5rem;
        text-align: center;
        font-style: normal;
    }
</style>

<script lang="ts">

import { defineComponent } from "vue";

import PageBase from "@/shared/components/common/PageBase";
import HeaderMessage from "@/components/HeaderMessage.vue";

export default defineComponent({
    name: "UpgradeInstalling",
    mixins: [PageBase],
    components: {
        HeaderMessage,
    },
    methods: {
        runInstall(): void {
            if (Auggie.PackageDownload.IsAborted()) {
                this.$router.push("/Upgrade/Failed");
                return;
            }
            const err = Auggie.PackageDownload.Install();
            if (err)
                this.$router.push("/Upgrade/Failed");
            else
                this.$router.push("/Upgrade/Installed");
        },
    },
    mounted(): void {
        setTimeout((): void => {
            this.runInstall();
        }, 100);
    },
});
</script>
